export default "__VITE_ASSET__DpTgqdbH__"